export default "__VITE_ASSET__DYPuoK1s__"